import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Modal, ModalHeading } from '@sainsburys-tech/luna-modal';
import { ButtonGroupPrimary, ButtonGroupSecondary, ButtonGroupWrapper, FilledButton, TextButton } from '@sainsburys-tech/luna-button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { GridItem, GridWrapper } from '@sainsburys-tech/luna-grid';
import { ProgressIndicator, ProgressSpinner } from '@sainsburys-tech/luna-progress';

import PropTypes from 'prop-types';

import * as actions from '../../../store/actions/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../../axios';

import classes from './LocationsSelection.module.scss';

import moment from 'moment';
import Input from '../../../components/UI/Input/Input';
import { toggleDates, updateObject } from '../../../shared/utility';
moment.locale('en-GB');

class LocationsSelection extends Component {
    state = {
        availableLocations: [],
        assignedLocations: [],
        endDate: moment('2999-12-28'),
        endDateFocused: false,
        startDateFocused: false,
        startDate: moment().startOf('week'),
        isValidDateRange: false,
        isValidStartDate: false,
        isValidEndDate: false
    };

    componentDidMount() {
        if (!this.props.locations || this.props.locations.length === 0) {
            this.props.onGetLocations();
        }
        this.checkDateRange();
    }

    componentDidUpdate() {
        if (this.props.assignedLocations !== this.state.assignedLocations && this.props.show === true) {
            this.setAvailableLocations();
        }
    }
    toggleDateHandler = identifier => {
        const date = toggleDates(identifier, this.state.startDate, this.state.endDate);
        this.dateChangedHandler(date, identifier);
    };
    setAvailableLocations = () => {
        const available = this.props.locations.filter(l => this.props.assignedLocations.filter(s => s.locationHeaderId === l.id).length === 0);
        this.setState({
            availableLocations: available,
            assignedLocations: this.props.assignedLocations
        });
    };
    loading = (
        <ProgressIndicator page loading={this.props.isLoading}>
            <ProgressSpinner light />
            Loading Locations...
        </ProgressIndicator>
    );

    onRowSelectHandler = e => {
        this.handleChange(e);
    };
    onSelectionChangeHandler = e => {
        this.handleChange(e);
    };

    setSelectedLocationsHandler = () => {
        this.props.onSetSelectedLocations(this.state.selectedLocations, this.state.startDate, this.state.endDate);
        this.props.close();
    };

    handleChange = e => {
        let value;
        if (Array.isArray(e.value)) {
            value = e.value;
        }
        else {
            value = e.data;
        }
        if (!e.originalEvent.ctrlKey) {
            if (Array.isArray(value)) {
                if (
                    this.state.selectedLocations &&
                    this.state.selectedLocations.length === 1 &&
                    this.state.selectedLocations.filter(r => r.id === value[0].id).length === 0
                ) {
                    this.setState([]);
                }
                else {
                    this.setState({ selectedLocations: value });
                }
            }
            else {
                if (
                    this.state.selectedLocations &&
                    this.state.selectedLocations.length === 1 &&
                    this.state.selectedLocations.filter(r => r.id === value.id).length > 0
                ) {
                    this.setState({ selectedLocations: [] });
                }
                else {
                    this.setState({ selectedLocations: value });
                }
            }
        }
        else if (Array.isArray(value)) {
            this.setState({ selectedLocations: value });
        }
        else {
            this.setState({ selectedLocations: [value] });
        }
    };

    focusedHandler = (event, identifier) => this.setState({ [`${identifier}Focused`]: event.focused });

    onFocusedHandler = event => event.currentTarget.select();

    dateChangedHandler = (event, identifier) => {
        const touched = updateObject(this.state.touched, { [identifier]: true });
        this.setState(
            () => ({ [identifier]: event, touched }),
            () => this.checkDateRange()
        );
    };

    checkDateRange = () => {
        let valid = true;

        let start = moment().startOf('day');
        let end = moment().startOf('day');

        if (this.state.startDate) start = this.state.startDate.startOf('day');
        if (this.state.endDate) end = this.state.endDate.startOf('day');

        if (start.isAfter(end.startOf('day')) || start.isBefore(moment('2019-01-06'))) valid = false;

        let validStart = false;
        let validEnd = false;

        if (this.state.startDate) validStart = this.state.startDate.format('dddd') === 'Sunday';
        if (this.state.endDate) validEnd = this.state.endDate.format('dddd') === 'Saturday';

        this.setState({
            isValidDateRange: valid,
            isValidStartDate: validStart,
            isValidEndDate: validEnd
        });

        return valid && validStart && validEnd;
    };

    getErrorMessage = type => {
        let errorMessage = '';

        if (!this.state.isValidDateRange) errorMessage = 'Invalid date range';

        if (!this.state[`isValid${type}`]) errorMessage = `Must be a ${type === 'StartDate' ? 'Sunday' : 'Saturday'}`;

        return errorMessage;
    };
    render() {
        if (this.props.isLoading) {
            return this.loading;
        }

        return (
            <Modal handleClose={this.props.close} open={this.props.show} className={classes.lunaDataTableStyle}>
                <ModalHeading element="h3">Select Locations</ModalHeading>
                <GridWrapper>
                    <GridItem size="1/2">
                        <Input
                            label="Start Date"
                            id="startDate"
                            dateChanged={event => this.dateChangedHandler(event, 'startDate')}
                            onFocused={event => this.focusedHandler(event, 'startDate')}
                            focused={this.state.startDateFocused}
                            value={this.state.startDate}
                            invalid={!this.state.isValidDateRange}
                            errorMessage={this.getErrorMessage('StartDate')}
                            elementType="datelabelled"
                            wkNoClick={() => this.toggleDateHandler('startDate')}
                        />
                    </GridItem>
                    <GridItem size="1/2">
                        <Input
                            label="End Date"
                            id="endDate"
                            dateChanged={event => this.dateChangedHandler(event, 'endDate')}
                            onFocused={event => this.focusedHandler(event, 'endDate')}
                            focused={this.state.endDateFocused}
                            value={this.state.endDate}
                            invalid={!this.state.isValidDateRange}
                            errorMessage={this.getErrorMessage('EndDate')}
                            elementType="datelabelled"
                            wkNoClick={() => this.toggleDateHandler('endDate')}
                        />
                    </GridItem>
                    <GridItem>
                        <DataTable
                            value={this.state.availableLocations}
                            responsive
                            paginator
                            rows={8}
                            rowsPerPageOptions={[5, 10, 15, 30, 50, 100]}
                            onSelectionChange={e => this.onSelectionChangeHandler(e)}
                            onRowSelect={e => this.onRowSelectHandler(e)}
                            selectionMode="multiple"
                            selection={this.state.selectedLocations}
                        >
                            <Column field="locationNo" header="No" filter sortable className={classes.leftAlign} style={{ width: '150px' }} />
                            <Column
                                field="locationName"
                                header="Name"
                                filter
                                sortable
                                filterMatchMode="contains"
                                style={{ textAlign: 'left', width: '200px' }}
                            />
                        </DataTable>
                    </GridItem>
                </GridWrapper>
                <ButtonGroupWrapper actionBar>
                    <ButtonGroupPrimary>
                        <FilledButton onClick={this.setSelectedLocationsHandler}>Apply</FilledButton>
                    </ButtonGroupPrimary>
                    <ButtonGroupSecondary>
                        <TextButton onClick={this.props.close}>Cancel</TextButton>
                    </ButtonGroupSecondary>
                </ButtonGroupWrapper>
            </Modal>
        );
    }
}

LocationsSelection.propTypes = {
    assignedLocations: PropTypes.array,
    close: PropTypes.func,
    isLoading: PropTypes.bool,
    locations: PropTypes.array,
    onGetLocations: PropTypes.func,
    onSetSelectedLocations: PropTypes.func,
    show: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        isLoading: state.location.loadingLocations,
        locations: state.location.locationHeaders,
        selectedLocations: state.location.selectedlocations
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetLocations: () => dispatch(actions.getLocations()),
        onUpdateSite: site => dispatch(actions.updateUserSite(site)),
        onSetSelectedLocations: (loc, fromDate, toDate) => dispatch(actions.setSelectedLocations(loc, fromDate, toDate))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(LocationsSelection, axios));
